import {
  Building2,
  FileText,
  LayoutDashboard,
  LogOut,
  Settings,
  Trash2,
  Users,
} from "lucide-react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { Button } from "../../components/ui/Button.jsx";
import { removeSuperAdminToken } from "../../services/authService.js";
import { cn } from "../../utils/className.js";

const navItems = [
  { to: "/super-admin/dashboard", icon: LayoutDashboard, label: "Dashboard" },
  { to: "/super-admin/users", icon: Users, label: "Users" },
  { to: "/super-admin/companies", icon: Building2, label: "Companies" },
  { to: "/super-admin/activity-logs", icon: FileText, label: "Activity Logs" },
  { to: "/super-admin/industry-templates", icon: Settings, label: "Industry Templates" },
  { to: "/super-admin/trash", icon: Trash2, label: "Trash" },
];

export default function SuperAdminLayout() {
  const navigate = useNavigate();

  const handleLogout = () => {
    removeSuperAdminToken();
    navigate("/super-admin/login");
  };

  return (
    <div className="flex h-screen bg-gray-50">
      {/* Sidebar */}
      <aside className="w-60 bg-white border-r border-gray-200 flex flex-col">
        <div className="p-5 border-b border-gray-100">
          <h1 className="text-base font-bold text-gray-900">LeadCRM</h1>
          <p className="text-[10px] text-gray-400 mt-0.5">Super Admin Panel</p>
        </div>

        <nav className="flex-1 p-3 space-y-1">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) =>
                cn(
                  "flex items-center gap-3 px-3 py-2 rounded-lg text-sm transition-colors",
                  isActive
                    ? "bg-[#00a8b4]/10 text-[#00a8b4] font-medium"
                    : "text-gray-600 hover:bg-gray-50"
                )
              }
            >
              <item.icon size={16} />
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="p-3 border-t border-gray-100">
          <Button
            variant="ghost"
            onClick={handleLogout}
            className="w-full justify-start gap-3 text-sm text-gray-500 hover:text-red-500"
          >
            <LogOut size={16} />
            Logout
          </Button>
        </div>
      </aside>

      {/* Main Content */}
      <main className="flex-1 overflow-y-auto">
        <div className="p-6 max-w-7xl mx-auto">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
